import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { timeout } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { CommonService } from './common.service';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class apiservice6 {

  constructor(private httpClient: HttpClient, private common: CommonService, private localstorage: LocalStorageService, private router: Router, private msg: ToastrService,) {

    this.common.ngOnInit();
  }

  /**
       * Perform a get request to the api
       */

  async GET(endpoint: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {

        endpoint = endpoint.replace("@user", "?userid=" + this.common.GetUser())

        let result = this.httpClient.get(apiservice6.getApiUrl() + endpoint, await this.buildRequestOptions())
          .pipe(timeout(50000));
        result.subscribe(async (response: any) => {

          resolve(response);
        },
          (err) => {
            console.log('Caught exception in GET request: ', err);
            reject(null);
            if (err.status == 401) {
              this.localstorage.clearAll();
              this.msg.error('Session Expired', "", { timeOut: 5000 });
              this.router.navigate(['auth/login']);
            }
            return;
          }
        );
      } catch (e) {
        console.log('Caught exception in GET request: ', e);
        reject(null);
        return;
      }
    });
  }


  async GETFILE(endpoint: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {

        endpoint = endpoint.replace("@user", "?userid=" + this.common.GetUser())

        let result = this.httpClient.get(apiservice6.getApiUrl() + endpoint, await this.buildRequestOptions_file())
          .pipe(timeout(50000));
        result.subscribe(async (response: any) => {

          resolve(response);
        },
          (err) => {
            console.log('Caught exception in GET request: ', err);


            reject(null);
            // this.localstorage.clearAll();
            // this.router.navigate(['login']);
            return;

          }
        );
      } catch (e) {

        console.log('Caught exception in GET request: ', e);
        reject(null);
        return;
      }

    });
  }
  /**
     * Perform a post request to the server.
     */
  async POST(endpoint: string, data: any = null, withTimeout = true): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let result: Observable<any>;
      try {
        result = await this.httpClient.post(apiservice6.getApiUrl() + endpoint, data, await this.buildRequestOptions()).pipe(timeout(withTimeout ? 15000 : 60000));
        result.subscribe(async (response: any) => {
          resolve(response);
          return;
        });
      } catch (e) {
        console.log('Caught exception in POST request: ', e);
        reject(null);
        return;
      }
    });
  }


  async POSTFORM(endpoint: string, data: any = null, withTimeout = true): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let result: Observable<any>;
      try {
        result = await this.httpClient.post(apiservice6.getApiUrl() + endpoint, data, await this.buildRequestOptions_form()).pipe(timeout(withTimeout ? 15000 : 60000));
        result.subscribe(async (response: any) => {
          resolve(response);
          return;
        });
      } catch (e) {
        console.log('Caught exception in POST request: ', e);
        reject(null);
        return;
      }
    });
  }

  /**
   * Perform a post request to the server.
   */
  async PUT(endpoint: string, data: any = null, withTimeout = true): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let result: Observable<any>;
      try {
        result = await this.httpClient.put(apiservice6.getApiUrl() + endpoint, data, await this.buildRequestOptions()).pipe(timeout(withTimeout ? 15000 : 60000));
        result.subscribe(async (response: any) => {
          resolve(response);
          return;
        });
      } catch (e) {
        console.log('Caught exception in PUT request: ', e);
        reject(null);
        return;
      }
    });
  }

  /**
 * Perform a delete request to the server.
 */
  async DELETE(endpoint: string, withTimeout = true): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let result: Observable<any>;
      try {
        result = await this.httpClient.delete(apiservice6.getApiUrl() + endpoint, await this.buildRequestOptions()).pipe(timeout(withTimeout ? 5000 : 60000));
        result.subscribe(async (response: any) => {
          resolve(response);
          return;
        });
      } catch (e) {
        console.log('Caught exception in DELETE request: ', e);
        reject(null);
        return;
      }
    });
  }

  /**
  * Genearate the request options for all httpclient call.
  */
  private async buildRequestOptions() {
    let options = { headers: await this.buildHeaders() };
    return options;
  }
  private async buildRequestOptions_form() {
    let options = { headers: await this.buildHeaders_form() };
    return options;
  }
  private async buildRequestOptions_file() {
    let options = { headers: await this.buildHeaders_file() };
    return options;
  }
  /**
  * Generate the headers that are required for all the requests.
  */
  private async buildHeaders() {
    var token = localStorage.getItem("Token")

    if (token) {
      token = token.replace(/^"(.*)"$/, '$1'); // Remove quotes from token start/end. This is a temp fix?!
    }
    let headers = new HttpHeaders({
      'Content-Type': environment.content_type,
      'Authorization': 'Bearer ' + token
    });
    return headers;
  }
  private async buildHeaders_form() {
    var token = localStorage.getItem("Token")

    if (token) {
      token = token.replace(/^"(.*)"$/, '$1'); // Remove quotes from token start/end. This is a temp fix?!
    }
    let headers = new HttpHeaders({
      //'Content-Type':  environment.content_type,
      'Authorization': 'Bearer ' + token
    });
    return headers;




  }
  private async buildHeaders_file() {
    var token = localStorage.getItem("Token")

    if (token) {
      token = token.replace(/^"(.*)"$/, '$1'); // Remove quotes from token start/end. This is a temp fix?!
    }
    let headers = new HttpHeaders({
      //'Content-Type':  environment.content_type,
      observe: 'response',
      responseType: 'blob',
      'Authorization': 'Bearer ' + token
    });
    return headers;
  }
  /**
* Get the api url to use through different environment strategies.
*/
  private static getApiUrl(): string {
    return environment.apiurl6;
  }


}
